import { memo } from 'react'

import MusicalChairs, { TEST_ID } from './MusicalChairs'

const MusicalChairsComponent = memo(MusicalChairs)

export { TEST_ID }

export default MusicalChairsComponent
